import { h, Component } from 'preact';
import { getCopy } from 'utils/copy';
import { joinClasses, parseDate } from 'utils/utils';
import pure from 'utils/pure';
import s from 'components/shared/countdown/countdown.sss';

const SECOND = 1000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export default @pure class Countdown extends Component {

	constructor(props) {
		super(props);

		// throw an error if anyone tries to use the component without a date
		// if (!this.props.date) {
		// 	throw 'Attempt to use the Countdown component without a date';
		// }

		this.startTimer = this.startTimer.bind(this);
		this.stopTimer = this.stopTimer.bind(this);
		this.updateTimeRemaining = this.updateTimeRemaining.bind(this);

		this.date = this.parseDate(props);

		this.state = {
			remanining: { days: 0, hours: 0, minutes: 0, seconds: 0 }
		};
	}

	componentDidMount() {
		this.startTimer();
	}

	componentWillReceiveProps(props) {
		if (props.date !== this.props.date || props.timeOffset !== this.props.timeOffset) {
			this.date = this.parseDate(props);
		}
	}

	componentWillUnmount() {
		this.stopTimer();
	}

	parseOffset(value) {
		if (value == undefined) {
			return null;
		}
		if (!Number.isNaN(+value) && Math.abs(value) < 15) {
			// Decimal format: -3.5
			return 60 * value;
		}
		if (typeof value === 'string') {
			// Regular format: -3:30 or 0800
			let match = value.trim().match(/^([+-]?)(\d\d??)(?::?(\d\d))?$/);
			if (!match) {
				return null;
			}
			let sign = match[1] === '-' ? -1 : +1;
			let hours = +match[2];
			let minutes = +match[3] || 0;
			return sign * (60 * hours + minutes);
		}
		return null;
	}
	parseDate(props = this.props) {
		let date = parseDate(props.date);
		let offsetAmount = this.parseOffset(props.timeOffset);
		if (offsetAmount !== null) {
			date.setMinutes(date.getMinutes() - date.getTimezoneOffset() - offsetAmount);
		}
		return date;
	}

	startTimer() {
		clearInterval(this.timer);
		this.counting = true;
		this.updateTimeRemaining();
		this.timer = setInterval(this.updateTimeRemaining, 1000);
	}

	stopTimer() {
		clearInterval(this.timer);
		this.counting = false;

		if (this.props.onComplete) {
			this.props.onComplete();
		}
	}

	updateTimeRemaining() {
		if (!this.date) {
			return this.stopTimer();
		}
		let diff = Math.max(this.date - Date.now(), 0);

		const seconds = Math.floor((diff / SECOND) % 60);
		const minutes = Math.floor((diff / MINUTE) % 60);
		const hours = Math.floor((diff / HOUR) % 24);
		const days = Math.floor(diff / DAY);

		if (!diff) {
			this.stopTimer();
		}

		this.setState({
			remanining: { days, hours, minutes, seconds }
		});
	}

	renderValue(value, copy) {
		return (
			<span class={s.denomination}>
				{value}
				{!this.props.hideLabels && <span class={s.label}>{getCopy(copy)}</span>}
			</span>
		);
	}

	render(props, state) {
		const {
			date,
			timeOffset,
			className,
			hideOnComplete = true, // (boolean) whether to hide the component once the countdown reaches 0
			hideLabels = false, // (boolean) whether or not to show the hour/minutes/seconds labels or just use :
			onComplete,
			copy,
			...remainingProps
		} = props;

		const remaining = state.remanining || {};

		const hideCountdown = !this.date || (!this.counting && hideOnComplete);

		let countdown;
		if (!hideCountdown) {
			countdown = (
				<time datetime={this.date.toISOString()} class={joinClasses(s.time, !hideLabels && s.showLabels)}>
					{this.renderValue(remaining.days, '$DAYS')}
					{this.renderValue(remaining.hours, '$HOURS')}
					{this.renderValue(remaining.minutes, '$MINUTES')}
					{this.renderValue(remaining.seconds, '$SECONDS')}
				</time>
			);
		}
		return (
			<div {...remainingProps} class={joinClasses(s.wrapper, className)}>
				{copy && <div class={s.copy}>{copy}</div>}
				{countdown}
			</div>
		);
	}
}
